import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { NoAuthApiRequest,ApiRequest } from "../pages/services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";

const Sidemenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const usrDetails = JSON.parse(localStorage.getItem("user"));
    const [openMenu, setOpenMenu] = useState(null);

    const [today,settoday]=useState();
    const [thisweek,setthisweek]=useState();
    const [thismonth,setthismonth]=useState();
    const [lastweek,setlastweek]=useState();

    useEffect(() => {

        if(usrDetails==null){
            navigate('/')
        }
        const storedMenu = localStorage.getItem("openMenu");
        if (storedMenu) {
            setOpenMenu(parseInt(storedMenu, 10));
        }
        FetchDailyTotal();
        // Ensure the submenu remains open if the current route matches a submenu path
        const activeMenu = menuItems.find(item =>
            item.submenus.some(sub => sub.path === location.pathname)
        );
        if (activeMenu) {
            setOpenMenu(activeMenu.id);
            localStorage.setItem("openMenu", activeMenu.id);
        }
    }, [location.pathname]);

    const handlelogout = () => {
        debugger;
        localStorage.removeItem("user");
         localStorage.removeItem("userremember");//, JSON.stringify(rememberedUser));
        //  var rememberedUser = localStorage.getItem("userremember");
        //  if(rememberedUser){
        //     rememberedUser= JSON.parse(rememberedUser);
        //     rememberedUser.RememberMe=false;
        //     localStorage.setItem("userremember", JSON.stringify(rememberedUser));
        //  }
        navigate("/");
    }

    const toggleSubmenu = (id) => {
        const newOpenMenu = openMenu === id ? null : id;
        setOpenMenu(newOpenMenu);
        localStorage.setItem("openMenu", newOpenMenu);
    };

     const FetchDailyTotal= async () => {
    
           if(usrDetails != null){
                const data = await ApiRequest(
                    ApiEndpoints.TimeSheet.TableHours(usrDetails.Id),
                    ApiEndpointMethod.Get,
                    null,
                    navigate
                  );

                  settoday(data.Item1);
                  setthisweek(data.Item2);
                  setlastweek(data.Item3);
                  setthismonth(data.Item4);

                }
            };
    
    
    const menuItems = [
        // { name: "Dashboard", path: "/dashboard", icon: "fa-home" , role:['admin','lead','employee'] ,isSubMenu:false},
        // { name: "Timesheet", path: "/timesheet",  icon: "fa-clock" ,role:['admin','lead','employee'],isSubMenu:true,
        //     lstMenulist: [
        //         { id: 21, name: "Daily", path: "/timesheet/daily" },
        //         { id: 22, name: "Weekly", path: "/timesheet/weekly" },
        //         { id: 23, name: "Monthly", path: "/timesheet/monthly" },
        //     ]
        // },
        // { name: "Clients", path: "/clients", icon: "fa-building" ,role:['admin'],isSubMenu:false},
        // { name: "Projects", path: "/", icon: "fa-project-diagram", role:['admin'] ,isSubMenu: true,
        //     lstMenulist:[
        //     { name: "Create", path: "/projects", icon: "", role:['admin'] ,isSubMenu:false},
        //     { name: "Project Users", path: "/project-users", icon: "",role:['admin'] ,isSubMenu:false}
        // ]},
        // // { name: "Projects", path: "/projects", icon: "fa-project-diagram", role:['admin'] },
        // { name: "Users", path: "/users", icon: "fa-users" ,role:['admin']},
        // { name: "Assign Users", path: "/assign-users", icon: "fa-tasks",role:['admin'] ,isSubMenu:false},
        // // { name: "Project Users", path: "/project-users", icon: "fa-users",role:['admin'] },
        { id: 1, name: "Dashboard", path: "/dashboard", icon: "fa-home", submenus: [], role:['admin','lead','employee'] },
        {
            id: 2, name: "Timesheet", path: "", icon: "fa-clock", submenus: [
                { id: 21, name: "Daily", path: "/timesheet/daily" },
                { id: 22, name: "Weekly", path: "/timesheet/weekly" },
                { id: 23, name: "Monthly", path: "/timesheet/monthly" },
                // { id: 24, name: "Import Time Sheet", path: "/timesheet/import-timesheet" },
            ],
            role:['admin','lead','employee']
        },
        { id: 3, name: "Clients", path: "/clients", icon: "fa-building", submenus: [],role:['admin'] },
        {
            id: 4, name: "Projects", path: "", icon: "fa-project-diagram", submenus: [
                { id: 41, name: "Create Project", path: "/projects" },
                { id: 42, name: "Project Users", path: "/project-users" },
                // { id: 43, name: "Project Details", path: "/project-details" },
            ],role:['admin']
        },
        {
            id: 5, name: "Users", path: "", icon: "fa-users", submenus: [
                { id: 51, name: "Create User", path: "/users" },
                { id: 52, name: "Team Users", path: "/team-users" },
            ],role:['admin']
        },
        { id: 6, name: "Reports", path: "", icon: "fa-file-alt", submenus: [
            { id: 61, name: "Download TimeSheets", path: "/reports" },
            ],role:['admin','lead','employee'] },
        { id: 7, name: "Logout", path: "", icon: "fa-sign-out", submenus: [],role:['admin','lead','employee']  },
    ];

    return (
        <>
            <div className="sidemenu">
                <div className="sidemenu-logo">
                    <img src="/assets/images/logo.png" height="36px" />
                </div>
                <div className='sidemenu-scroll'>
                <div className="sidemenu-table">
                    <table className="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th width="40%"></th>
                                <th width="30%">Billable Hours</th>
                                <th width="30%">Total Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Today</td>
                                <td style={{textAlign:"right"}}>{(today?.Billable??0.00).toFixed(2)}</td>
                                <td style={{textAlign:"right"}}>{(today?.Total??0.00).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>This Week</td>
                                <td style={{textAlign:"right"}}>{(thisweek?.Billable??0.00).toFixed(2)}</td>
                                <td style={{textAlign:"right"}}>{(thisweek?.Total??0.00).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Last Week</td>
                                <td style={{textAlign:"right"}}>{(lastweek?.Billable??0.00).toFixed(2)}</td>
                                <td style={{textAlign:"right"}}>{(lastweek?.Total??0.00).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>This Month</td>
                                <td style={{textAlign:"right"}}>{(thismonth?.Billable??0.00).toFixed(2)}</td>
                                <td style={{textAlign:"right"}}>{(thismonth?.Total??0.00).toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                    <ol className="sidemenu-nav">
                        {/* {menuItems.map((item, index) => (
                        item.role.includes(usrDetails.RoleName) && (
                            item.isSubMenu==false && (
                            <li key={index} className="sidemenu-item">
                                <Link to={item.path} className={location.pathname === item.path ? "active" : ""}>
                                    <i className={`fas ${item.icon} me-2 fa-fw`}></i>{item.name}</Link>
                            </li>
                            )
                            item.isSubMenu==true && (
                                <ul key={index} className="sidemenu-item">
                                    <Link>
                                        <i className={`fas ${item.icon} me-2 fa-fw`}></i>{item.name}</Link>
                                        {item.lstMenulist.map((item1, index1)) => (
                                                <li key={index1} className="sidemenu-item">
                                                <Link to={item1.path} className={location.pathname === item1.path ? "active" : ""}>
                                                    <i className={`fas ${item1.icon} me-2 fa-fw`}></i>{item1.name}</Link>
                                            </li>
                                        )}
                                </ul>
                                )
                          )
                        ))} */}
                        {menuItems.map((item) => (
                           item.role && Array.isArray(item.role) && item.role.includes(usrDetails?.RoleName) && (
                        <li key={item.id} className={`sidemenu-item relative ${openMenu === item.id ? "submenu-open" : ""}`}>
                            <div className="d-flex justify-content-between align-items-center">
                                {item.name === "Logout" ? (
                                    <Link
                                        to="/"
                                        className="sidemenu-item"
                                        onClick={() => {
                                            handlelogout();
                                        }}
                                    >
                                        <i className={`fas ${item.icon} me-2 fa-fw`}></i> {item.name}
                                    </Link>
                                ) : (
                                <Link
                                    to={item.path}
                                    className={`${location.pathname === item.path ? "active" : ""}`}
                                    onClick={() => item.submenus.length > 0 && toggleSubmenu(item.id)}
                                >
                                    <i className={`fas ${item.icon} me-2 fa-fw`}></i> {item.name}
                                </Link>
                                 )}
                                {item.submenus.length > 0 && (
                                    <button
                                        onClick={() => toggleSubmenu(item.id)}
                                        className="btn btn-sm btn-link text-white p-0"
                                    >
                                        {openMenu === item.id ? <i className="fas fa-chevron-down"></i> : <i className="fas fa-chevron-right"></i>}
                                    </button>
                                )}
                       
                            </div>

                            {item.submenus.length > 0 && openMenu === item.id && (
                                <ol className="submenu">
                                    {item.submenus.map((submenu) => (
                                        <li key={submenu.id}>
                                            <Link
                                                to={submenu.path}
                                                className={`${location.pathname === submenu.path ? "active" : ""}`}
                                            >
                                                {submenu.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ol>
                            )}
                        </li>
                             )
                    ))}
                    </ol>
                </div >
            </div >
        </>
    );
};

export default Sidemenu;